module.exports = __webpack_public_path__ + "static/img/4.e303a21.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/2/1/eng/4.png
// module id = hKbc
// module chunks = 0